import React from 'react';
import EditProfileForm from "./EditProfileForm";
import {compose} from "redux";
import {connect} from "react-redux";
import {updateProfileFields} from "../../actions/users";

export default compose(
  connect(
    (state, props) => ({
      current: state.profile
    }),
    (dispatch, props) => ({
      onSubmit: (values) => {
        dispatch(updateProfileFields(values));
        props.history.push('/settings/profile');
      }
    })
  )
)(EditProfileForm);


// WEBPACK FOOTER //
// ./src/components/Settings/EditProfile.js